export default __webpack_public_path__ + "static/media/slider3.9d836229.jpg";